import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import './style.scss'

const Badge = ({ color, label, palette, size, variation, extraClasses }) => {
  const classes = {
    'gdpp-component': true,
    [`fil-badge--${size}`]: size !== 'standard',
    [`fil-badge--${palette}${variation !== 'solid' ? '-outline' : ''}-${color}`]: true
  }

  return (
    <span role="status" aria-label={label} className={classnames('fil-badge', classes, extraClasses)}>
      {label}
    </span>
  )
}

Badge.propTypes = {
  label: PropTypes.string.isRequired,
  /**
   * primary: information | success | error | warning | notification
   * secondary: black | grey | teal | purple | purple-light | yellow
   */
  color: PropTypes.string,
  palette: PropTypes.string,
  size: PropTypes.string,
  variation: PropTypes.string,
  extraClasses: PropTypes.string
}

Badge.defaultProps = {
  color: 'information',
  palette: 'primary',
  size: 'standard',
  variation: 'solid',
  extraClasses: ''
}

export default Badge
